import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';
import { Icon } from '@/modules/core/app/enums/Icon';

export class MessageClaraDraftSourceType extends Enum {
  key!: string;
  icon!: Icon;
  isProse!: boolean;
  value!: string;

  static DOCUMENT: MessageClaraDraftSourceType = {
    key: 'document',
    icon: Icon.COMMON_FILE_TEXT_ALTERNATE,
    isProse: true,
    get value() {
      return Lang.t('message.clara-draft-source-type-document');
    }
  };

  static FILE_SECTION: MessageClaraDraftSourceType = {
    key: 'file_section',
    icon: Icon.LIST_BULLETS,
    isProse: false,
    get value() {
      return Lang.t('message.clara-draft-source-type-file-section');
    }
  };

  static INBOX_MESSAGE: MessageClaraDraftSourceType = {
    key: 'inbox_message',
    icon: Icon.MESSAGES,
    isProse: true,
    get value() {
      return Lang.t('message.clara-draft-source-type-inbox-message');
    }
  };

  static INTERNAL_NOTE: MessageClaraDraftSourceType = {
    key: 'internal_note',
    icon: Icon.NOTE_PIN,
    isProse: true,
    get value() {
      return Lang.t('message.clara-draft-source-type-internal-note');
    }
  };

  static INTERNAL_COMMENT: MessageClaraDraftSourceType = {
    key: 'internal_comment',
    icon: Icon.TEAM_CHAT,
    isProse: true,
    get value() {
      return Lang.t('message.clara-draft-source-type-internal-comment');
    }
  };

  static CLARA_KNOWLEDGE: MessageClaraDraftSourceType = {
    key: 'clara_knowledge',
    icon: Icon.MAGIC_STARS,
    isProse: true,
    get value() {
      return Lang.t('message.clara-draft-source-type-clara-knowledge');
    }
  };

  static CONTENT_LIBRARY: MessageClaraDraftSourceType = {
    key: 'content_library',
    icon: Icon.BOOK_FLIP_PAGE,
    isProse: true,
    get value() {
      return Lang.t('message.clara-draft-source-type-content-library');
    }
  };

  static LAW: MessageClaraDraftSourceType = {
    key: 'law',
    icon: Icon.LEGAL_SCALE_UNEQUAL,
    isProse: true,
    get value() {
      return Lang.t('message.clara-draft-source-type-law');
    }
  };

  static WEB_ARTICLE: MessageClaraDraftSourceType = {
    key: 'web_article',
    icon: Icon.HYPERLINK,
    isProse: true,
    get value() {
      return Lang.t('message.clara-draft-source-type-web-article');
    }
  };

  static HELP_ARTICLE: MessageClaraDraftSourceType = {
    key: 'help_article',
    icon: Icon.QUESTION_CIRCLE,
    isProse: true,
    get value() {
      return Lang.t('message.clara-draft-source-type-help-article');
    }
  };

  static CALENDAR: MessageClaraDraftSourceType = {
    key: 'calendar',
    icon: Icon.CALENDAR,
    isProse: false,
    get value() {
      return Lang.t('message.clara-draft-source-type-calendar');
    }
  };
}
